/**
 * Creates a DOM rectangle at a given position and with an optional given size
 * @internal
 */
export function createDOMRect(
  position: {
    /** @defaultValue 0 */
    x?: number;
    /** @defaultValue 0 */
    y?: number;
  },
  size?: { height: number; width: number },
): () => DOMRect {
  const { x = 0, y = 0 } = position;

  return () => {
    const values = {
      bottom: y,
      height: size ? size.height : 0,
      width: size ? size.width : 0,
      top: y,
      left: x,
      right: x,
      x: x,
      y: y,
    };

    return {
      ...values,
      toJSON: () => JSON.parse(JSON.stringify(values)),
    };
  };
}
